import React, { Component } from 'react';

import Row from '../../components/row';
import PageTitle from '../../components/page-title';
import RelationSummary from '../../components/relation-summary';

import './products.css';
import { connect } from 'react-redux';

class Products extends Component {
	render() {
		const { translations, relations } = this.props;
		return (
			<div className="view-products">
				<Row>
					<PageTitle>{translations.title}</PageTitle>
				</Row>
				<Row>
					{relations && (
						<RelationSummary
							{...relations}
							debtor_number_label={translations.clientNumber}
						/>
					)}
				</Row>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		relations: state.data.relations,
		translations: Object.assign(
			state.translations.products,
			state.translations.general
		),
	};
}

export default connect(mapStateToProps)(Products);
